// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.MainPage_mainPage_div__UU2ht {
  background-color: aqua;
}

.MainPage_joinButton__l6ops {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: black;
  color: white;
  font-size: 1.2rem;
  font-weight: bold;
  padding: 15px 30px;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  outline: none;
  z-index: 1000;
  text-transform: uppercase;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  animation: MainPage_fadeIn__1jrFp 0.5s ease-in-out;
}
.MainPage_joinButton__l6ops:hover {
  background: #1a1a1a;
  transform: scale(1.05);
}
.MainPage_joinButton__l6ops:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  border: 2px solid transparent;
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
  animation: MainPage_neon__2UMRv 2s linear infinite;
}
.MainPage_joinButton__l6ops:after {
  content: "";
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  background: linear-gradient(90deg, #a40606, #e52661, #dc2424, #c90b0b);
  background-size: 400%;
  z-index: -1;
  border-radius: inherit;
  filter: blur(5px);
  animation: MainPage_neon-border__wMgqh 3s linear infinite;
}

/* Добавляем стиль для кнопки, когда страница внизу */
.MainPage_moveUp__odLzN {
  bottom: 100px;
}

.MainPage_qrContainer__qleTY {
  position: fixed;
  bottom: 50px;
  left: 50px;
  z-index: 1000;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}
.MainPage_qrContainer__qleTY.MainPage_moveUp__odLzN {
  bottom: 100px;
}

.MainPage_qrWrapper__1ar5g {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 15px;
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}
.MainPage_qrWrapper__1ar5g:hover {
  transform: scale(1.5);
  background: rgba(0, 0, 0, 0.9);
  box-shadow: 0 0 25px rgba(255, 255, 255, 0.4);
  border: 2px solid #fff;
}
.MainPage_qrWrapper__1ar5g:hover .MainPage_qrText__xeTfR {
  opacity: 1;
}

.MainPage_qrImage__E1Sac {
  width: 90px;
  height: 90px;
  border-radius: 10px;
  transition: transform 0.3s ease;
}

.MainPage_qrText__xeTfR {
  position: relative;
  bottom: auto;
  margin-top: 8px;
  color: white;
  font-size: 0.7rem;
  text-align: center;
  opacity: 1;
  width: 120px;
  text-shadow: 1px 1px 2px black;
  transition: none;
}

/* Анимация появления */
@keyframes MainPage_fadeIn__1jrFp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* Анимация для свечения */
@keyframes MainPage_neon__2UMRv {
  0% {
    box-shadow: 0 0 5px rgba(255, 255, 255, 0.2);
  }
  50% {
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.8);
  }
  100% {
    box-shadow: 0 0 5px rgba(255, 255, 255, 0.2);
  }
}
/* Анимация для бегущих полосок */
@keyframes MainPage_neon-border__wMgqh {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
/* Мобильная версия */
@media (max-width: 768px) {
  .MainPage_qrContainer__qleTY {
    left: 15%;
    bottom: 15%;
  }
  .MainPage_qrContainer__qleTY.MainPage_moveUp__odLzN {
    bottom: 30%;
  }
  .MainPage_qrWrapper__1ar5g {
    padding: 5px;
  }
  .MainPage_qrImage__E1Sac {
    width: 90px;
    height: 90px;
  }
  .MainPage_qrText__xeTfR {
    font-size: 0.6rem;
  }
  .MainPage_joinButton__l6ops {
    font-size: 1rem;
    padding: 10px 20px;
    bottom: 5%;
    right: 15%;
  }
  .MainPage_moveUp__odLzN {
    bottom: 30%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/mainPage/MainPage.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,sBAAA;AAEJ;;AACA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,gCAAA;EACA,kDAAA;AAEJ;AAAI;EACI,mBAAA;EACA,sBAAA;AAER;AACI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,6BAAA;EACA,6CAAA;EACA,kDAAA;AACR;AAEI;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,sEAAA;EACA,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,yDAAA;AAAR;;AAIA,qDAAA;AACA;EACI,aAAA;AADJ;;AAIA;EACI,eAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,gCAAA;EACA,eAAA;AADJ;AAGI;EACI,aAAA;AADR;;AAKA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,6CAAA;EACA,yBAAA;EACA,6BAAA;AAFJ;AAII;EACI,qBAAA;EACA,8BAAA;EACA,6CAAA;EACA,sBAAA;AAFR;AAIQ;EACI,UAAA;AAFZ;;AAOA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;AAJJ;;AAOA,uBAAA;AACA;EACI;IACI,UAAA;IACA,2BAAA;EAJN;EAME;IACI,UAAA;IACA,wBAAA;EAJN;AACF;AAOA,0BAAA;AACA;EACI;IACI,4CAAA;EALN;EAOE;IACI,6CAAA;EALN;EAOE;IACI,4CAAA;EALN;AACF;AAQA,iCAAA;AACA;EACI;IACI,2BAAA;EANN;EAQE;IACI,6BAAA;EANN;EAQE;IACI,2BAAA;EANN;AACF;AASA,qBAAA;AACA;EACI;IACI,SAAA;IACA,WAAA;EAPN;EASM;IACI,WAAA;EAPV;EAWE;IACI,YAAA;EATN;EAYE;IACI,WAAA;IACA,YAAA;EAVN;EAaE;IACI,iBAAA;EAXN;EAcE;IACI,eAAA;IACA,kBAAA;IACA,UAAA;IACA,UAAA;EAZN;EAeE;IACI,WAAA;EAbN;AACF","sourcesContent":[".mainPage_div {\n    background-color: aqua;\n}\n\n.joinButton {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    background: black;\n    color: white;\n    font-size: 1.2rem;\n    font-weight: bold;\n    padding: 15px 30px;\n    border: none;\n    border-radius: 50px;\n    cursor: pointer;\n    outline: none;\n    z-index: 1000;\n    text-transform: uppercase;\n    overflow: hidden;\n    transition: all 0.3s ease-in-out;\n    animation: fadeIn 0.5s ease-in-out;\n\n    &:hover {\n        background: #1a1a1a;\n        transform: scale(1.05);\n    }\n\n    &:before {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        border-radius: inherit;\n        border: 2px solid transparent;\n        box-shadow: 0 0 20px rgba(255, 255, 255, 0.5);\n        animation: neon 2s linear infinite;\n    }\n\n    &:after {\n        content: \"\";\n        position: absolute;\n        top: -5px;\n        left: -5px;\n        right: -5px;\n        bottom: -5px;\n        background: linear-gradient(90deg, #a40606, #e52661, #dc2424, #c90b0b);\n        background-size: 400%;\n        z-index: -1;\n        border-radius: inherit;\n        filter: blur(5px);\n        animation: neon-border 3s linear infinite;\n    }\n}\n\n/* Добавляем стиль для кнопки, когда страница внизу */\n.moveUp {\n    bottom: 100px;\n}\n\n.qrContainer {\n    position: fixed;\n    bottom: 50px;\n    left: 50px;\n    z-index: 1000;\n    transition: all 0.3s ease-in-out;\n    cursor: pointer;\n\n    &.moveUp {\n        bottom: 100px;\n    }\n}\n\n.qrWrapper {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 10px;\n    background: rgba(0, 0, 0, 0.8);\n    border-radius: 15px;\n    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);\n    transition: all 0.3s ease;\n    border: 2px solid transparent;\n\n    &:hover {\n        transform: scale(1.5);\n        background: rgba(0, 0, 0, 0.9);\n        box-shadow: 0 0 25px rgba(255, 255, 255, 0.4);\n        border: 2px solid #fff;\n\n        .qrText {\n            opacity: 1;\n        }\n    }\n}\n\n.qrImage {\n    width: 90px;\n    height: 90px;\n    border-radius: 10px;\n    transition: transform 0.3s ease;\n}\n\n.qrText {\n    position: relative;\n    bottom: auto;\n    margin-top: 8px;\n    color: white;\n    font-size: 0.7rem;\n    text-align: center;\n    opacity: 1;\n    width: 120px;\n    text-shadow: 1px 1px 2px black;\n    transition: none;\n}\n\n/* Анимация появления */\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Анимация для свечения */\n@keyframes neon {\n    0% {\n        box-shadow: 0 0 5px rgba(255, 255, 255, 0.2);\n    }\n    50% {\n        box-shadow: 0 0 15px rgba(255, 255, 255, 0.8);\n    }\n    100% {\n        box-shadow: 0 0 5px rgba(255, 255, 255, 0.2);\n    }\n}\n\n/* Анимация для бегущих полосок */\n@keyframes neon-border {\n    0% {\n        background-position: 0% 50%;\n    }\n    50% {\n        background-position: 100% 50%;\n    }\n    100% {\n        background-position: 0% 50%;\n    }\n}\n\n/* Мобильная версия */\n@media (max-width: 768px) {\n    .qrContainer {\n        left: 15%;\n        bottom: 15%;\n\n        &.moveUp {\n            bottom: 30%;\n        }\n    }\n\n    .qrWrapper {\n        padding: 5px;\n    }\n\n    .qrImage {\n        width: 90px;\n        height: 90px;\n    }\n\n    .qrText {\n        font-size: 0.6rem;\n    }\n\n    .joinButton {\n        font-size: 1rem;\n        padding: 10px 20px;\n        bottom: 5%;\n        right: 15%;\n    }\n\n    .moveUp {\n        bottom: 30%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainPage_div": `MainPage_mainPage_div__UU2ht`,
	"joinButton": `MainPage_joinButton__l6ops`,
	"fadeIn": `MainPage_fadeIn__1jrFp`,
	"neon": `MainPage_neon__2UMRv`,
	"neon-border": `MainPage_neon-border__wMgqh`,
	"moveUp": `MainPage_moveUp__odLzN`,
	"qrContainer": `MainPage_qrContainer__qleTY`,
	"qrWrapper": `MainPage_qrWrapper__1ar5g`,
	"qrText": `MainPage_qrText__xeTfR`,
	"qrImage": `MainPage_qrImage__E1Sac`
};
export default ___CSS_LOADER_EXPORT___;
